// extracted by css-extract-rspack-plugin
export default {"NewRulesetButton":"OverviewPage-module__NewRulesetButton___f6Ec"};